import { Box, makeStyles } from '@material-ui/core';
import Text from '../Text';
import { BED_STATUS_REMARK_COLOR } from '../../comm/constant';

const useStyles = makeStyles((theme) => ({
  root: ({ margin, colour }) => ({
    width: '100%',
    maxWidth: '11.125rem',
    height: '100%',
    padding: '1.063rem 0.625rem 1.063rem 1.25rem',
    borderRadius: '4px',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: BED_STATUS_REMARK_COLOR[colour]?.bgColor ?? '#fff',
    margin,
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.312rem',
      height: '100%',
      backgroundColor: BED_STATUS_REMARK_COLOR[colour]?.leftColor ?? '#e4e7eb',
      zIndex: '9',
    },
  }),
}));

const Remark = ({ margin = '0 0 0.625rem', remark = '', colour }) => {
  const classes = useStyles({ margin, colour });

  return (
    <Box className={classes.root}>
      <Text color="#2E4469">{remark}</Text>
    </Box>
  );
};

export default Remark;
